import type { Scope } from '../../shared/levels.js';

// Display label for an entry's scope. The data value stays 'stretch'/'in_role';
// the UI reads "above band" / "in role" so the concept is self-explanatory.
export function scopeLabel(scope: Scope): string {
  return scope === 'stretch' ? 'above band' : 'in role';
}
